import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 18H16V6H18V18ZM6 18V6L14.5 12L6 18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SkipNext"
);
